import api from '@/api'
import * as types from './types'

export default {
  async getCalibrationHomepageMessage({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getCalibrationHomepageMessage()
        .then(response => {
          commit(types.SET_CALIBRATION_HOMEPAGE_MESSAGE, response.data)
          resolve(response)
        })
    })
  },
  async saveCalibrationHomepageMessage({ commit, state }, data) {
    console.log('saveCalibrationHomepageMessage')

    return new Promise((resolve, reject) => {
      var request = {
        Text: data.homepageMessage,
        IsActive: data.isActive
      }

      api.saveCalibrationHomepageMessage(request)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/actions.js